import { Provider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'projects/communication/src/app/services';
import { CommunicationService } from '../communication';
import { ServerConfigService } from '../server-config.service';
import { ServerDefaultConfigService } from '../server-default-config.service';

/**
 * Provee la contrucción de una instancia del servicio que se encvargará de las
 * comunicaciones remotas y que implementará la interfaz de comunicaión remota
 *
 * IRemoteCommunication
 */
const communicationServiceFactory = (http: HttpClient, serverConfig: ServerConfigService) => {
  return new ApiService(http, serverConfig);
};

/**
 * Provider que define el alias para la utilización del servicio que se encargará
 * de la comunicación remota y que implementará el método communicationServiceFactory
 * para la creación
 */
export const communicationServiceProvider: Provider = {
  provide: CommunicationService,
  useFactory: communicationServiceFactory,
  deps: [HttpClient, ServerDefaultConfigService]
};
